<template>
  <div class="holder">
    <div class="outer" ref='outer' :class="{ 'unlocked': unlocked }">
      <div class="msg_wrapper"> 
        <div class="message unlock" v-if="unlocked">{{lbl.serial.Used}}</div>
        <div class="message" v-if="!unlocked">{{lbl.serial.slide_to_unmask}}</div>
      </div>
      <div class="lock" ref='lock'
        @mousedown='dragStart'
        @touchstart='dragStart'>
        <img src="@/assets/icon/serial/arrow.svg" alt="arrow" v-if="!unlocked" />
        <img src="@/assets/icon/serial/arrow_disable.svg" alt="arrow" v-if="unlocked" />
      </div> 
    </div> 
  </div> 
</template>
   
<script> 
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
  name: "unlock",
  data() {
    return {
      unlocked: false,
      lockRect: null,
      dragProps: null 
    };
  },
  mixins: [LocaleMixin],
  computed: {
    outerRect() {
        return this.$refs['outer'].getBoundingClientRect()
    },
    isTouch() {
        return 'ontouchstart' in document.documentElement
    }
  },
  methods: {
    dragStart(e) {
      if (this.unlocked) return
      this.lockRect = this.$refs['lock'].getBoundingClientRect()
      const x = this.getX(e)
      this.dragProps = {
        start: this.lockRect.left - this.outerRect.left,
        mouseStart: x,
        newX: 0,
      }
      this.$refs['lock'].classList.add('dragging')
      document.addEventListener('mousemove', this.dragLock, false)
      document.addEventListener('touchmove', this.dragLock, false)
      document.addEventListener('mouseup', this.dragStop)
      document.addEventListener('touchend', this.dragStop)
    },
    dragStop(reset) {
      this.$refs['lock'].classList.remove('dragging')
      if (reset !== false) {
        this.$refs['lock'].style.left = '0px'
      }
      document.removeEventListener('mousemove', this.dragLock, false)
      document.removeEventListener('touchmove', this.dragLock, false)
      document.removeEventListener('mouseup', this.dragStop)
      document.removeEventListener('touchend', this.dragStop)
    },
    unlock() {
      this.dragStop(false)
      this.unlocked = true
      this.$emit('unlock')
    },
    dragLock(e) {
      e.preventDefault()
      const posX = this.getX(e)
      const mouseDiff = posX - this.dragProps.mouseStart
      const maxX = this.outerRect.width - this.lockRect.width - 10
      let newX = this.dragProps.start + mouseDiff
      newX = this.clamp(newX, 0, maxX)
      this.$refs['lock'].style.left = newX + 'px'
      if (newX >= maxX) {
        this.unlock()
      }
    },
    clamp(value, min, max) {
      return Math.min(Math.max(value, min), max)
    },
    getX(event) {
      if (this.isTouch === true) {
        return event.touches[0].pageX
      } else {
        return event.clientX
      }
    },
  },
};
</script>

<style lang="scss" scoped>  
.holder {
  width: 214px;
  text-align: center;
  margin: 0 auto;
  height: 45px;
  overflow: hidden;
  border-radius: 60px;

  .msg_wrapper {
    position: absolute;
    left: 0;
    right: 0;
    top:0;
    bottom: 0; 
    display: flex;
    justify-content: center;
    align-items: center; 
    z-index: 0;
  }
  .message {
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding: 10px;
      color: #1C3E95;
      height: 45px;
      &.unlock {
        color: #9B9B9B;
      }
  }
  .outer {
    height: 45px; 
    overflow: hidden;
    border-radius: 60px;
    background: #fff;
    display: inline-block;
    width: 100%;
    position: relative;
    user-select: none;
    border: 1px solid #1C3E95;
    .lock {
      width: 37px;
      height: 37px; 
      cursor: pointer;
      position: relative;
      border-radius: 50%;
      left: 0;
      transition: background 0.2s ease-out, left 0.3s ease-out; 
      margin: 3px;
      &.dragging {
        transition: none;
      }
    }
    &.unlocked {
      opacity: 0.8; 
      border: 1px solid #CCC;
      background: #CCC;

      .lock { 
        cursor: none;
      }
    }
  }
}

</style>